import { useEffect, useState } from 'react';

import { TILE_HEIGHT, TILE_WIDTH } from ':cloud/widgets/buildQuest/constants';

export function usePointsChip(ref: React.RefObject<HTMLDivElement>) {
  const [pointsChipWidth, setPointsChipWidth] = useState<number>(0);
  useEffect(() => {
    if (ref.current) {
      const rect = ref.current.getBoundingClientRect();
      setPointsChipWidth(rect.width);
    }
  }, [ref]);

  // only applicable to the CompletedTile component
  const pointsChipCoordinates = {
    x: TILE_WIDTH / 2 - pointsChipWidth / 2,
    y: TILE_HEIGHT - 38,
  };

  return { pointsChipWidth, pointsChipCoordinates };
}
